import $ from 'jquery'

$(function () {
    let w = $("#topbar").width();
    if (w > 1024) {
        $(".logoleiste-titelbild img").width(w + "px");
    }
});
